import axios from "axios";
import { host } from "./utilities";

export const getReferenceDataListAxios = (bundle) => (config) =>
  axios.get(`${host()}/reference-data/${bundle}`, config);

export const getBuyBackSubtypesListAxios = () =>
  getReferenceDataListAxios("buyback-subtypes");

